import { TotalsQuery } from '../../types/__generated-graphQL__';

export const getTotalFromGqlTotals = (
  totals: TotalsQuery['totals'],
  measurementDomain: string,
  currencyCode: string,
): number => {
  const specifiedMeasurementValues = totals.find(
    (total) => total.measurementDomain === measurementDomain,
  );
  if (!specifiedMeasurementValues) return 0;

  const specifiedCurrencyValue = specifiedMeasurementValues.amounts.find(
    (measurement) => {
      return measurement.unit.toUpperCase() === currencyCode.toUpperCase();
    },
  );
  if (!specifiedCurrencyValue) return 0;

  return specifiedCurrencyValue.value;
};
